module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"imprint":"Imprint","privacyPolicy":"Privacy policy","termsOfUse":"Terms of use"},"de":{"imprint":"Impressum","privacyPolicy":"Datenschutz","termsOfUse":"AGB"}}')
  delete Component.options._Ctor
}
